import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { Typography } from '../Typography';
import TableHeadSortToggle from './TableHeadSortToggle';
import { HeadCell } from './types';

interface TableCellWithSortingProps extends Pick<HeadCell<unknown>, 'label' | 'align'> {
    sort: string | false;
    setSort(arg: string | false): void;
}

const TableCellWithSorting = ({ align, sort, setSort, label }: TableCellWithSortingProps) => {
    const { t } = useTranslation();
    return (
        <Box display='flex' justifyContent={align} alignItems='center'>
            <TableHeadSortToggle sort={sort} setSort={setSort} />
            <Box mr={0.5} />
            <Typography
                uppercase
                color='textSecondary'
                variant='caption'
            >
                {t(...label)}
            </Typography>
        </Box>
    );
};

export default TableCellWithSorting;
